export default "__VITE_ASSET__4beb6dab__"